<template>
  <div class="main">
    <div class="header-new fixed-dom">
      <div class="layout-logo">
        <img src="../assets/logosadd.png" width="380px"  />
      </div>
      <router-link class="jumpLogin" to="login">管理系统</router-link>
    </div>
    <div class="nav">
      <ul>
        <template v-for="n in 2">
          <li>
            <div
              class="navitem"
              :class="n == activeNum ? 'activeNavItem' : ''"
            ></div>
          </li>
        </template>
      </ul>
    </div>

    <div class="box">
      <div class="page page-one actived" ref="scrollOne"></div>
      <div class="page page-two actived" ref="scrollTwo"></div>
    </div>
    <div class="layout-footer-center">
      <p class="footer-font">
        Copyright © 2022 北京海阅天成科技有限公司 All Rights Reserved.
      </p>

      <div class="btnFlex">
        <p class="footer-font">
          备案号：
          <a
            class="footer-font"
            target="_blank"
            rel="nofollow"
            href="https://beian.miit.gov.cn"
            >{{ beianNum }}</a
          >
        </p>
        <p class="footer-font toBa">
          <a
            class="footer-font"
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502048252"
            >京公网安备 11010502048252号</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      beianNum: "",
      activeNum: 1,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    this.beianNum = "京ICP备2021030542号-1";
  },
  methods: {
    handleScroll() {
      if (document.readyState === "complete") {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (this.$refs.scrollOne) {
          let oneHeight = this.$refs.scrollOne.offsetHeight;
          let twoHeight = this.$refs.scrollTwo.offsetHeight + oneHeight;
          if (scrollTop < oneHeight) {
            this.activeNum = 1;
          } else if (scrollTop >= oneHeight && scrollTop < twoHeight) {
            this.activeNum = 2;
          } else if (scrollTop >= twoHeight) {
            this.activeNum = 2;
          }
        }else{
          return
        }
      }
    },
  },
};
</script>

<style lang="less">
@import "./commonEdu.less";
</style>



// WEBPACK FOOTER //
// index.vue?6d1ecb52